export default "__VITE_ASSET__9ffd2d3a__"